import {autoRegister} from "../../container";
import {RequestSugarFactory} from "../common/requestSugar";

export type LivepollSubmitRequest = {
    opinion: number;
}

export type OpinionDistribution = {
    group: number;
    percentage: number;
}

@autoRegister()
export class LivepollService {

    public async submitOpinion(pollId: string, request: LivepollSubmitRequest): Promise<boolean> {
        const response = await fetch(`/enbw-eop/eop-app-feedback/rest/stable/livepoll/${pollId}/opinion`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify(request)
        });
        return response.ok;
    }

    public async getResults(pollId: string, groups: number): Promise<Array<OpinionDistribution>> {
        const response = await fetch(`/enbw-eop/eop-app-feedback/rest/stable/livepoll/${pollId}?amountOfGroups=${groups}`);
        return await response.json();
    }
}
